import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-obtener-contrasena',
  templateUrl: './obtener-contrasena.component.html',
  styleUrls: ['./obtener-contrasena.component.scss']
})
export class ObtenerContrasenaComponent implements OnInit {
  celular = '';
  message;
  data;
  respuestaSendMessage:any;
  constructor(private _sendMessage : LoginService) { }

  ngOnInit(): void {
  }

  sendMessage(){
    if(this.celular == ''){
      this.message = 'Por favor ingresa un número de celular válido';
    }else{
      this.message = '';
    }

    this.data = {
      'celular':this.celular
    }

    this._sendMessage.sendMessage(this.data).subscribe(
      response => {
        this.respuestaSendMessage = response;
        if(this.respuestaSendMessage.success){
          this.message = '<p class="center">Te hemos enviado un mensaje de texto con tu contraseña, inicia sesión <a href="/app">aquí</a><br>';
        }else {
          alert('No se cargaron los datos');
        }

      },
      error =>{
        console.log('error: ', error)
        this.message = 'Hubo un problema, por favor intenta más tarde';
      }
    )
    

  }
}
